import { observer } from 'mobx-react-lite'
import { useRef, FC, useState, RefObject, useEffect } from 'react'
import { TypeTabsStyled } from './style'
import { useStore } from '@/store/index'
import { Tabs } from '@gate/gui'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import { PriceTableItemProps } from '..'
import { eventTracker } from '@/utils/collectEvent'
import { HOME_PAGE_URL } from '@/constants/index'
import useLangPrefix from '@/hooks/useLangPrefix'
import { useAdapter } from '@/components/Adapter'

const TypeTabs: FC<PriceTableItemProps & { tabRefs: RefObject<HTMLButtonElement>[] }> = ({ tabRefs, onChangeTab }) => {
  const router = useRouter()
  const { t } = useTranslation()
  const { isZh } = useLangPrefix()

  const typeAllTabsRefs = useRef<HTMLDivElement | null>(null)
  const typeFiatTabsRefs = useRef<HTMLDivElement | null>(null)
  const { isH5 } = useAdapter()

  const { typeTabsList, typeTab, setTypeTab, priceTab, fiatTrace, titleTab } = useStore().baseStore
  const [isShowAllTab, setIsShowAllTab] = useState(false)
  const [isShowFiatTab, setIsShowFiaTab] = useState(false)

  const [visibleAllIcon, setVisibleAllIcon] = useState<boolean>(true)
  const [visibleFiatIcon, setVisibleFiatIcon] = useState<boolean>(true)

  const onTabChange = (tab: string) => {
    // 埋点操作
    if (priceTab === HOME_PAGE_URL.Market && tab !== 'all') {
      const item = typeTabsList?.find(item => item?.category_id === tab)
      item?.category_id &&
        eventTracker('price_treade_tab_click', {
          second_tab_name: item?.category_id,
        })
    }
    onChangeTab(priceTab === HOME_PAGE_URL.FIAT ? HOME_PAGE_URL.FIAT : HOME_PAGE_URL.Market, tab)
    setTypeTab(tab)

    const urlParams: any = { ...(router.query || {}) }
    delete urlParams.path

    if (tab !== 'all') {
      urlParams.category = tab
    } else {
      delete urlParams.category
    }

    const queryString = new URLSearchParams(urlParams as Record<string, string>).toString()
    const newUrl = `${window.location.pathname}${queryString ? `?${queryString}` : ''}`

    window.history.pushState(null, '', newUrl)
  }

  useEffect(() => {
    if (titleTab === HOME_PAGE_URL.Market || priceTab === HOME_PAGE_URL.Market) {
      if (typeAllTabsRefs?.current) {
        setVisibleAllIcon(
          typeAllTabsRefs?.current?.scrollHeight > typeAllTabsRefs?.current?.clientHeight ||
            typeAllTabsRefs?.current?.scrollHeight > 24
        )
      }
    }
    if (priceTab === HOME_PAGE_URL.FIAT) {
      if (typeFiatTabsRefs?.current) {
        setVisibleFiatIcon(
          typeFiatTabsRefs?.current?.scrollHeight > typeFiatTabsRefs?.current?.clientHeight ||
            typeFiatTabsRefs?.current?.scrollHeight > 24
        )
      }
    }
  }, [priceTab, titleTab])

  return (
    <TypeTabsStyled>
      {priceTab === HOME_PAGE_URL.Market ? (
        <Tabs
          type="fourth-capsule"
          value={typeTab}
          onTabChange={onTabChange}
          styles={{
            tabsList: {
              height: isH5 ? '100%' : isShowAllTab ? '100%' : '24px',
              overflow: 'scroll',
              // pointerEvents: 'none',
              padding: 0,
              rowGap: '8px',
              '&::-webkit-scrollbar': {
                display: 'none',
              },
            },
          }}
        >
          <Tabs.List ref={typeAllTabsRefs}>
            <Tabs.Tab ref={tabRefs[0]} value={'all'}>
              {t('P.All1')}
            </Tabs.Tab>
            {typeTabsList?.map((item, index) => (
              <Tabs.Tab ref={tabRefs[index + 1]} key={item?.id} value={item?.id}>
                {item?.[router.locale ?? ''] ?? (isZh ? (item?.zh ?? item?.en) : item?.en)}
              </Tabs.Tab>
            ))}
          </Tabs.List>
        </Tabs>
      ) : null}

      {priceTab === HOME_PAGE_URL.FIAT ? (
        <Tabs
          type="fourth-capsule"
          value={typeTab}
          onTabChange={onTabChange}
          styles={{
            tabsList: {
              height: isH5 ? '100%' : isShowFiatTab ? '100%' : '24px',
              overflow: 'scroll',
              // pointerEvents: 'none',
              padding: 0,
              rowGap: '8px',
              '&::-webkit-scrollbar': {
                display: 'none',
              },
            },
          }}
        >
          <Tabs.List ref={typeFiatTabsRefs}>
            <Tabs.Tab ref={tabRefs[0]} value={'all'}>
              {t('P.All1')}
            </Tabs.Tab>
            {fiatTrace?.map((item, index) => (
              <Tabs.Tab ref={tabRefs[index + 1]} key={item?.id} value={item?.id}>
                {item?.label}
              </Tabs.Tab>
            ))}
          </Tabs.List>
        </Tabs>
      ) : null}

      {!isH5 && visibleAllIcon && priceTab === HOME_PAGE_URL.Market ? (
        <div
          className="price-type-tab-icon"
          onClick={() => {
            setIsShowAllTab(flag => !flag)
          }}
        >
          <svg className="iconpark-icon">
            <use href={`#v31-16px-line-${isShowAllTab ? 'shangjiantou' : 'xiajiantou'}`}></use>
          </svg>
        </div>
      ) : null}

      {!isH5 && visibleFiatIcon && priceTab === HOME_PAGE_URL.FIAT ? (
        <div className="price-type-tab-icon" onClick={() => setIsShowFiaTab(flag => !flag)}>
          <svg className="iconpark-icon">
            <use href={`#v31-16px-line-${isShowFiatTab ? 'shangjiantou' : 'xiajiantou'}`}></use>
          </svg>
        </div>
      ) : null}
    </TypeTabsStyled>
  )
}

export default observer(TypeTabs)
